import { get } from 'js/lib/user';

import { VIVA_EXAM_ENABLED_ASSIGNMENTS } from 'bundles/academic-integrity/components/viva-exam/constants';
import AcademicIntegrityExperiments from 'bundles/epic/clients/AcademicIntegrity';

export const excludeLearnerFromIdVerificationFingerprint = (): boolean => {
  const userId = get().id?.toString();
  const exclusionList = AcademicIntegrityExperiments.get('idVerificationFingerprintExclusionList') ?? [];
  if (exclusionList.length > 0) {
    return exclusionList.includes(userId);
  }
  return false;
};

export const isIdVerificationFingerprintEnabled = (courseId: string): boolean => {
  if (excludeLearnerFromIdVerificationFingerprint()) {
    return false;
  }
  // eslint-disable-next-line camelcase
  return AcademicIntegrityExperiments.get('enableIdVerificationFingerprint', { course_id: courseId }) ?? false;
};

export const isVivaExamEnabled = (courseId: string, itemId: string): boolean => {
  const byCourse = VIVA_EXAM_ENABLED_ASSIGNMENTS as Record<string, Record<string, boolean> | undefined>;
  return byCourse[courseId]?.[itemId] === true;
};

export const isProctoringResultsAppEnabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableProctoringResultsAppEnabled') ?? false;
};

export const isVivaExamFeedbackEnabled = (courseId?: string): boolean => {
  if (courseId) {
    const byCourse = VIVA_EXAM_ENABLED_ASSIGNMENTS as Record<string, Record<string, boolean> | undefined>;
    return byCourse[courseId]?.feedback ?? false;
  }
  return false;
};

export const isCourseraProctoringExperimentEnabled = (): string => {
  return AcademicIntegrityExperiments.get('enableCourseraProctoringExperiment');
};

export const isCourseInProctoringExperiment = (courseId?: string): boolean => {
  if (courseId) {
    const experimentCourses = AcademicIntegrityExperiments.get('courseraProctoringExperimentCourse') ?? [];
    return experimentCourses.includes(courseId);
  }
  return false;
};

export const isHonorCodeAgreementV2Enabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableHonorCodeAgreementV2') ?? false;
};

/**
 * Check if Arkose Labs bot detection is enabled for assignment submissions.
 * This controls loading the Arkose client-side script and token validation.
 */
export const isArkoseBotDetectionEnabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableArkoseBotDetection') ?? false;
};

export const isGradedLabsEnabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableGradedLabs') ?? false;
};
